import { boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { Polygon } from '../../../ui/geometry/Polygon';
import { Parameter } from '../Parameter';

import { Certainty } from './Certainty';
import { Parameter as SlopeDirectionParameter } from './slope-direction/Parameter';
import { Source } from './Source';

export const Type = intersect(Polygon)(
	intersect(
		partial({
			discarded: boolean,
		})
	)(
		struct({
			id: string,

			// points

			pitch: Parameter,
			overhang: Parameter,
			heelHeight: Parameter,
			bearingHeight: Parameter,
			slopeDirection: SlopeDirectionParameter,

			colour: string,
			certainty: Certainty,
			source: Source,
		})
	)
);
